<template>
    <div v-if="user != undefined && value != undefined && value.teilnehmer != null" >
        <anfragen-anzeige-info-adress-box v-model="value" :class="darkmode ? 'bg-dark text-light border-secondary' : ''" />
        <div v-if="value.teilnehmer != null" :class="darkmode ? 'd-flex flex-row p-3 border border-bottom-0 bg-dark text-light border-secondary' : 'd-flex flex-row p-3 border border-bottom-0'">
            <span v-b-popover.hover.topright="'Lege fest, ob du deine Handynummer mit diesem Nutzer teilen willst.'">
                Handynummer teilen
            </span>
            <b-form-checkbox v-model="value.includeHandy" 
                class="ml-3" 
                @change="updateAnfrageHandler(value)" 
                :disabled="handyDisabled" 
                switch
            />
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { BFormCheckbox, VBPopover } from "bootstrap-vue"
import { setAlert } from '../tools'
import AnfragenAnzeigeInfoAdressBox from '../components/AnfragenAnzeigeInfoAdressBox.vue'
export default {
    name: "AnfragenAnzeigeInfo",
    components: {
        AnfragenAnzeigeInfoAdressBox,
        BFormCheckbox
    },
    directives:{
        'b-popover': VBPopover
    },
    props: {
        value: undefined
    },
    computed: {
        ...mapGetters(['user', 'darkmode']),
        handyDisabled: function () {
            return this.value.teilnehmer == null || this.user.handy == null || this.user.handy == ''
        }
    },
    methods: {
        ...mapActions(['updateAnfrage', 'updateUser']),
        async updateAnfrageHandler(anfrage) {
            try {
                await this.updateAnfrage(anfrage)
            }
            catch (err) {
                setAlert(this, err.response.data, 'Laden fehlgeschlagen', 'danger')
            }
        }
    },
    async mounted(){
        if(this.user == undefined)
            await this.updateUser()
    }
}
</script>